import React from 'react';
import { normalizePaymentRequestStatus, SAVE_ALLOWED_STATUSES, toDisplayStatus } from './paymentRequestStatuses';
import { getStatusColorClass } from '../../utils/awardStatusColor';
import cn from 'classnames';

interface StatusBannerProps {
  status?: string | null;
}

export const StatusBanner: React.FC<StatusBannerProps> = ({ status }) => {
  const safeStatus = typeof status === 'string' ? status : '';

  if (!safeStatus.trim()) {
    return null;
  }

  const normalizedStatus = normalizePaymentRequestStatus(safeStatus);
  const isReadOnly = !SAVE_ALLOWED_STATUSES.has(normalizedStatus);

  return (
    <div className='mb-3 text-lg'>
      <span className='font-bold'>Current Status:</span>
      <span className={cn('text-lg font-semibold pl-1', getStatusColorClass(normalizedStatus))}>{toDisplayStatus(safeStatus)}</span>
      {isReadOnly && <span className='text-lg font-semibold text-orange pl-1'>(Read Only)</span>}
    </div>
  );
};
